import { changeTitle } from '../util';
import React from 'react';
import PropTypes from 'prop-types';
import { redirectAction } from '../actions/redirect';

class TitledComponent extends React.Component {
  componentDidMount() {
    changeTitle(this.props.title);
  }

  goto(location) {
    this.props.dispatch(redirectAction(location));
  }
}

TitledComponent.defaultProps = {
  dispatch: () => null,
};

TitledComponent.propTypes = {
  title: PropTypes.string.isRequired,
  dispatch: PropTypes.func,
};

export default TitledComponent;



// WEBPACK FOOTER //
// ./src/components/titled-component.jsx